// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2765":"14906b6b","4613":"14906b6b"}[chunkId] + ".chunk.css";
};